// Shows the customer's Category (the raw staff_code, e.g. "STAR-R0-C3",
// "REG-R0-C0", or "FirstOrder") exactly as stored, and picks a chip color
// from the tier prefix purely for visual distinction.

const colorForTier = (code) => {
  if (code.startsWith('STAR')) return 'success';
  if (code.startsWith('VIP')) return 'warning';
  if (code.startsWith('REG')) return 'info';
  return 'default'; // NEW, FirstOrder, or anything else
};

/**
 * Returns { label, color } for a MUI Chip, or null if there is nothing to show.
 * label = the exact Category value (marketing wants the raw code shown).
 */
export const getCategoryChip = (category) => {
  if (!category) return null;
  const raw = String(category).trim();
  if (!raw) return null;

  return { label: raw, color: colorForTier(raw.toUpperCase()) };
};
